export class LogoDto {
    public id: number | undefined = undefined;
    public data: string | undefined = undefined;
    public format: string | undefined = undefined;
}